/**
 * Builds the shared grouped-control CSS classes for a consumer.
 *
 * Returns an empty list when the control is not in a group (falsy `position`),
 * otherwise the `grouped` base class plus the position/direction modifier.
 * Spread the result into `clsx(...)` at the call site.
 */
export function getGroupedControlClassNames(styles, { position, direction, hasAction, validation }) {
    if (!position) {
        return [];
    }
    const classNames = [styles.grouped, styles[`grouped-${direction}-${position}`]];
    if (hasAction) {
        classNames.push(styles['grouped-with-action']);
    }
    if (validation) {
        // State class drives the outward validation color (and invalid ring) in SCSS.
        // Every control gets it so each re-asserts its own outward edges on focus.
        classNames.push(validation === 'error' ? styles['grouped-in-error'] : styles['grouped-in-warning']);
        // Only the leading (inline-start) controls draw the thick validation seam:
        // the first/only control horizontally, every control vertically.
        const isLeading = direction === 'vertical' || position === 'first' || position === 'only';
        if (isLeading) {
            classNames.push(styles['grouped-validation']);
        }
    }
    return classNames;
}
//# sourceMappingURL=grouped-control-styles.js.map